import { render } from "./Rubros.vue?vue&type=template&id=5cf1e684"
import script from "./Rubros.vue?vue&type=script&lang=js"
export * from "./Rubros.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__